<template>
  <v-switch
    v-model="readFilter"
    :label="$t('chat.filterRead')"
    data-testid="sms-context-menu-read"
  ></v-switch>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-readFilter',
  computed: {
    ...mapGetters({
      read: 'chat/SmsFilters/read'
    }),
    readFilter: {
      get () { return this.read },
      set (read) { this.setRead(read) }
    }
  },
  methods: {
    ...mapActions({
      setRead: 'chat/SmsFilters/filterRead'
    })
  }
}
</script>

<style>

</style>
